import React from 'react';

interface BellIconProps {
  width?: number | string;
  height?: number | string;
  fill?: string;
  className?: string;
}

const BellIcon: React.FC<BellIconProps> = ({
  width = 24,
  height = 24,
  fill = '#0D0D0D',
  className
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.0256 17.0449H9.97481V17.333C9.97481 18.4833 10.8907 19.4003 12.0002 19.4004C13.1097 19.4004 14.0256 18.4833 14.0256 17.333V17.0449ZM17.5256 10.2227C17.5256 7.10865 15.0428 4.5996 12.0002 4.59961C8.9577 4.59968 6.47481 7.10871 6.47481 10.2227V13.5312C6.47476 13.8456 6.35211 14.1484 6.13106 14.373L5.79024 14.7197C5.67297 14.8389 5.66154 14.8533 5.6545 14.8633C5.62925 14.899 5.61113 14.9408 5.60372 14.9863C5.60164 14.9992 5.59981 15.0183 5.59981 15.1875C5.59981 15.3653 5.60012 15.4743 5.6047 15.5566C5.60844 15.6237 5.61441 15.6468 5.61544 15.6504C5.64452 15.738 5.71105 15.8029 5.79024 15.8301C5.79474 15.8312 5.81657 15.8365 5.87423 15.8398C5.95362 15.8444 6.05935 15.8447 6.2336 15.8447H17.7668C17.9408 15.8447 18.0466 15.8444 18.1262 15.8398C18.1843 15.8365 18.2067 15.8312 18.2111 15.8301C18.2893 15.8032 18.3556 15.7389 18.385 15.6504C18.386 15.6467 18.392 15.6236 18.3957 15.5566C18.4003 15.4743 18.4006 15.3653 18.4006 15.1875C18.4006 15.0194 18.3978 14.9995 18.3957 14.9863C18.3881 14.9397 18.3712 14.8979 18.3469 14.8633C18.3401 14.8536 18.328 14.8394 18.2102 14.7197L17.8693 14.373C17.6481 14.1482 17.5257 13.8452 17.5256 13.5312V10.2227ZM18.7258 13.5312H18.7248L19.0656 13.8779C19.1558 13.9695 19.2502 14.0622 19.3264 14.1699C19.4589 14.3575 19.5452 14.5719 19.5813 14.7949C19.6022 14.9247 19.5998 15.0556 19.5998 15.1875C19.5998 15.4824 19.6078 15.7758 19.5236 16.0293C19.3783 16.4665 19.0392 16.8153 18.5998 16.9658C18.346 17.0527 18.0524 17.0449 17.7668 17.0449H15.2258V17.333C15.2258 19.1282 13.7902 20.5996 12.0002 20.5996C10.2103 20.5995 8.7756 19.1282 8.7756 17.333V17.0449H6.2336C5.94787 17.0449 5.65536 17.0527 5.40157 16.9658C4.9632 16.8156 4.6224 16.4674 4.47677 16.0293C4.39259 15.7758 4.4006 15.4824 4.4006 15.1875C4.40059 15.0568 4.39813 14.925 4.41915 14.7949C4.45546 14.5706 4.54223 14.3564 4.67403 14.1699C4.7501 14.0623 4.84347 13.9707 4.93477 13.8779L5.2756 13.5312V10.2227C5.2756 6.46383 8.27723 3.40047 12.0002 3.40039C15.7232 3.40038 18.7258 6.46378 18.7258 10.2227V13.5312Z"
        fill={fill}
      />
    </svg>
  );
};

export default BellIcon;

